import { Theme } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { getWindowHeight } from "util/isAppRunningInIframe";

export const useStyles = makeStyles((theme: Theme) => {
  const windowHeight: string = getWindowHeight();
  return {
    wrapper: {
      paddingTop: theme.spacing(7.3),
      minHeight: windowHeight,
      maxHeight: windowHeight,
      boxSizing: "border-box",
    },
    content: {
      margin: theme.spacing(2),
      flexGrow: 1,
    },
    progress: {
      position: "absolute",
      left: 0,
      right: 0,
      margin: "auto",
      top: "calc(50% - 20px)",
    },
    hidePadding: {
      paddingTop: 0,
    },
  };
});
